module.exports = __webpack_public_path__ + "static/media/30.537af655.JPG";